import React, { useEffect } from 'react';
import { useVoteStore } from '../../stores/voteStore';
import { usePayment } from '../../hooks/usePayment';
import { LoadingSpinner } from '../shared/LoadingSpinner';
import { CheckCircle, XCircle, ExternalLink } from 'lucide-react';

export const PaymentStatus = () => {
  const { selectedTier, phoneNumber } = useVoteStore();
  const { 
    initializePayment, 
    verifyPayment,
    isLoading, 
    paymentUrl, 
    reference 
  } = usePayment();

  // Vérifier périodiquement le statut du paiement
  useEffect(() => {
    if (reference) {
      const interval = setInterval(() => {
        verifyPayment();
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [reference, verifyPayment]);

  if (!selectedTier || !phoneNumber) return null;

  if (isLoading) {
    return (
      <div className="text-center py-4">
        <LoadingSpinner />
        <p className="mt-2 text-gray-600">Initialisation du paiement...</p>
      </div>
    );
  }

  if (paymentUrl) {
    return (
      <div className="space-y-4">
        <div className="bg-green-50 text-green-800 p-4 rounded-lg flex items-center">
          <CheckCircle className="h-5 w-5 mr-2" />
          <span>Paiement initialisé avec succès</span>
        </div>
        <a
          href={paymentUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-full bg-indigo-600 text-white py-3 px-4 rounded-md hover:bg-indigo-700 transition-colors gap-2"
        >
          <span>Procéder au paiement</span>
          <ExternalLink className="h-4 w-4" />
        </a>
        <p className="text-sm text-gray-500 text-center">
          Une fois le paiement effectué, votre vote sera automatiquement comptabilisé
        </p>
      </div>
    );
  }

  return (
    <button
      onClick={() => initializePayment()}
      disabled={!phoneNumber}
      className="w-full bg-indigo-600 text-white py-3 rounded-md hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
    >
      Voter maintenant ({selectedTier.amount} XAF)
    </button>
  );
};